
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as indexqAwRMJdkb1H2CJlzE1iXM18sQtVw4SdPN9zaeTBQYDYMeta } from "/app/pages/assets/companies/index.vue?macro=true";
import { default as indexzrJhi5LEbAHRH9l2yKbLAmVpi7Bamwk13AR_hwwVSAUMeta } from "/app/pages/assets/properties/index.vue?macro=true";
import { default as assetsliep8h2BYRyTp2J4IZ6VAIePHJBLDz3qcavkfmSjjZwMeta } from "/app/pages/assets.vue?macro=true";
import { default as indexvhfhWVotO_456VvDOq_45cYkZMmeSIieYf1jIKy2UpS3yT0Meta } from "/app/pages/auth/index.vue?macro=true";
import { default as index06RuUPKkpIkYJ1u5ZQ6kHhkE76Z6rwcTsSwg0fLJR9IMeta } from "/app/pages/login/index.vue?macro=true";
import { default as indexP_T7wPh_aodPu5ikFWVi4tb5ggCS9bYgYggORuX_45lvAMeta } from "/app/pages/reports/index.vue?macro=true";
import { default as indexo4LA2msHJdAhkTreUNmi16kssM8xQi3fuvGCmtIyx_458Meta } from "/app/pages/testbed/index.vue?macro=true";
import { default as indexn6qc1p3ftV2qG3p0drs6HbQADMirvpNTQqQIGdK5yW8Meta } from "/app/pages/accounts/index.vue?macro=true";
import { default as indexue5j_Et5mhqqBBcCWL1GznXMyvUiFfGBAFCpWE1OZ8IMeta } from "/app/pages/rentroll/index.vue?macro=true";
import { default as indexDLzw_45g6D6DIAJf6VenrnDjf_u_45_OCTUbhH1U0CiVKeoMeta } from "/app/pages/settings/index.vue?macro=true";
import { default as indexFEuC4nsE4XgRvk4cE71tSnJukot7yzowrMxDtdUmEZ0Meta } from "/app/pages/analytics/index.vue?macro=true";
import { default as indexyd_SiUZ4WtGOjI_45NWcmzbxrpck0DglH5iJtjlQn_J9EMeta } from "/app/pages/opextracker/index.vue?macro=true";
import { default as index3cHpOvA8brJXgzMtG6LWNabMqYFTIkQke_45LjYkzstkUMeta } from "/app/pages/canvas-reports/index.vue?macro=true";
import { default as indexMfGT2nk6w99ic4drNmoBM88izrSkPHdgtGY25TQscEQMeta } from "/app/pages/portfolio/[portfolioId]/opex/index.vue?macro=true";
import { default as index_xtNTiUSv_CPL_BHyp2HJ6cvzcxqg1oc56RDLPdOYicMeta } from "/app/pages/portfolio/[portfolioId]/balance/index.vue?macro=true";
import { default as indexWam_45_4570N4ddTMTKznsQPhnZw9FTh7T1Y9jEVO5FPTAAMeta } from "/app/pages/portfolio/[portfolioId]/overview/index.vue?macro=true";
import { default as indexzTLpu_457WEAKbKR6GIC0E4avosjEOih21PxG3_45zZ_SdoMeta } from "/app/pages/portfolio/[portfolioId]/companies/index.vue?macro=true";
import { default as indexwTC9RbmdAHnv1ueZzPz8zWfZNKy0D5qJFoVjdJcr9YcMeta } from "/app/pages/portfolio/[portfolioId]/tenancies/index.vue?macro=true";
import { default as indexgA_45gNnvtp8mPPrLjcE0V7xB0oCC8Eou3do8dAZdDdeIMeta } from "/app/pages/portfolio/[portfolioId]/properties/index.vue?macro=true";
import { default as _91portfolioId_93NK7CyweArchQhrjerISCwU_45Mb65q5wnQ4jddVm8GkxkMeta } from "/app/pages/portfolio/[portfolioId].vue?macro=true";
import { default as index34RgdgDbCdEU_0iPDn1_YPpcKPnPXMlQmXk0NkcnTwwMeta } from "/app/pages/reports/[layoutId]/index.vue?macro=true";
import { default as print6uUuyU8UjrqAorMcD7dnN0BUCO2UB6mr1SJ9sUTGeIQMeta } from "/app/pages/reports/[layoutId]/print.vue?macro=true";
import { default as indexhXQzdj6WAZrM17sk_45s_xhq2pUzXGLyG8dzlKQbXBiXAMeta } from "/app/pages/datamanagement/datamapping/index.vue?macro=true";
import { default as indexFPJTe_OR0mnGy3kJHyROhocuFCsOv6C0uUOFNbht0lQMeta } from "/app/pages/datamanagement/datamapping/account-mapping/index.vue?macro=true";
import { default as indexs0hcL3SSzowMbsRcLOppM5vJfP7LlYIPUSw1fmHG3DAMeta } from "/app/pages/datamanagement/datamapping/tenancy-mapping/index.vue?macro=true";
import { default as indexUfE2tjLZpCkx0f_jAK5DVRu2Gn64MW8Ft_45kZ7kmV2NEMeta } from "/app/pages/datamanagement/datamapping/category-mapping/index.vue?macro=true";
import { default as indexNENiFS5L4pzSPu2GLZ9TSdUYyKov3cHR22r1mKrmSlsMeta } from "/app/pages/datamanagement/datamapping/property-mapping/index.vue?macro=true";
import { default as index3BjguiFbNJbVWYhid45VkQwDQZm44fiT0tGbfxJmfzMMeta } from "/app/pages/datamanagement/datamapping/portfolio-mapping/index.vue?macro=true";
import { default as indexqTXYXUqnEkn_45ZOPW9OQZYjQSVcpqhX8Y03P_45PUxMA_kMeta } from "/app/pages/datamanagement/datamapping/custom-fields-mapping/index.vue?macro=true";
import { default as datamappingZJmlTkd0VHccM0wtstRIg_455r9dwXJNDF7OS70DsYFL8Meta } from "/app/pages/datamanagement/datamapping.vue?macro=true";
import { default as indexyHIMvAz9s5ISBOmtZZRfZrUsh7etYM7QRBSJz4TTmpMMeta } from "/app/pages/portfolio/tenancy/[tenancyId]/sales/index.vue?macro=true";
import { default as indexHCenz4Ym8Ww10_RNom0R3NyDh9JvgCdm0_45bLoZm6kOAMeta } from "/app/pages/portfolio/tenancy/[tenancyId]/tenant/index.vue?macro=true";
import { default as index_45hEU_45cf1pXdtdFiBYWvoijMm2C5m1EFhip1nCTvBoCgMeta } from "/app/pages/portfolio/tenancy/[tenancyId]/arrears/index.vue?macro=true";
import { default as indexJsnC2BMsQLrr8PVGjWtA1yTbe5vMFZAOcyBL0M6x5TMMeta } from "/app/pages/portfolio/tenancy/[tenancyId]/capexes/index.vue?macro=true";
import { default as indexYpeXsxpE2DoxW5PPcJMAeH5YDexkww7QtzKqWwhAn0UMeta } from "/app/pages/portfolio/tenancy/[tenancyId]/overview/index.vue?macro=true";
import { default as indexLJ_klL44QOcllz4Pq6ukkGfHQJn7md4RVwZO8wP4HNUMeta } from "/app/pages/portfolio/tenancy/[tenancyId]/valuations/index.vue?macro=true";
import { default as index3vc8Nx4i5vliA_tPE79rxHG3IUAFe3LJONFEjb4dOl0Meta } from "/app/pages/portfolio/tenancy/[tenancyId]/account-statement/index.vue?macro=true";
import { default as _91tenancyId_93c13vDpEW57ZttQNZ_MXOdO_WiUtvTJnmjlC_4501fgc6gMeta } from "/app/pages/portfolio/tenancy/[tenancyId].vue?macro=true";
import { default as indexufNdeO2Dkolhklrp5jZycakSTaJGianSgs4liHpEp8YMeta } from "/app/pages/datamanagement/pipelines/index.vue?macro=true";
import { default as indexA2lzFAJVQq8gp76u61vhSW_455LdFy3CBYCDXAnSdHmlgMeta } from "/app/pages/portfolio/property/[propertyId]/opex/index.vue?macro=true";
import { default as indexCbbzVGmVZAhn5BHHkVO1C_45DI1ziASPbr8dIBAFojDJgMeta } from "/app/pages/portfolio/property/[propertyId]/sales/index.vue?macro=true";
import { default as index1QMZFMw1x7R7NXxN4hh2nxd3L39uC3fr1xkaFFoeHKMMeta } from "/app/pages/portfolio/property/[propertyId]/units/index.vue?macro=true";
import { default as indexcGr4E8HEGlogOCjWTFnUs83O2tBitWosRvkFym8jS0wMeta } from "/app/pages/portfolio/property/[propertyId]/balance/index.vue?macro=true";
import { default as indexttSv5bKQHbU42v1Aqg5GibxgOIFuMJg9_nQVoHiVdWkMeta } from "/app/pages/portfolio/property/[propertyId]/capexes/index.vue?macro=true";
import { default as indexjZdWdjqZYsO90HuMt19CnuSg0tHhiHgGw4KL7ybpdwEMeta } from "/app/pages/portfolio/property/[propertyId]/overview/index.vue?macro=true";
import { default as index53BmTfpDVqO2ZfCKxBLJgIhEF4P_R0YPjG_xvIV_45u68Meta } from "/app/pages/portfolio/property/[propertyId]/valuations/index.vue?macro=true";
import { default as indexpRPsxfvWi7jOuHVDMwPue8tEwrSgdQIlrU4isa8d_nMMeta } from "/app/pages/portfolio/property/[propertyId]/actionplans/index.vue?macro=true";
import { default as index0Pk1jyMINNSOCKqqiB1unFeK2Adh_A0jnx4dK4a_45oSsMeta } from "/app/pages/portfolio/property/[propertyId]/overview-old/index.vue?macro=true";
import { default as _91propertyId_930CI0l93fSxNf0QVSpjk6HMLDXWx4XyiHWQz4DDoU2NYMeta } from "/app/pages/portfolio/property/[propertyId].vue?macro=true";
import { default as index_45oldwhaWD8Z_454BiiW7xGxhN8VUjdfZ6Q7sS1c1ba8ORZIH0Meta } from "/app/pages/datamanagement/pipelines/index-old.vue?macro=true";
import { default as index_D42z69_45fxSl7TqtDg_bjWG7ueun1bxaGdSZQArNsQwMeta } from "/app/pages/datamanagement/integrationhub/index.vue?macro=true";
import { default as _91pipelineId_93Ezr3hm_GVB5EIMm3rZR_45krJ_Kht_45I7ppYnmd22WXPMcMeta } from "/app/pages/datamanagement/pipelines/[pipelineId].vue?macro=true";
import { default as _91integrationName_93_p_45YhN6C1j6dP6xTR_450SeidhbUc1GqRtNmpVCQVyXOMMeta } from "/app/pages/datamanagement/integrationhub/[integrationName].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "assets",
    path: "/assets",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/assets.vue"),
    children: [
  {
    name: "assets-companies",
    path: "companies",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/assets/companies/index.vue")
  },
  {
    name: "assets-properties",
    path: "properties",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/assets/properties/index.vue")
  }
]
  },
  {
    name: "auth",
    path: "/auth",
    meta: { ...(indexvhfhWVotO_456VvDOq_45cYkZMmeSIieYf1jIKy2UpS3yT0Meta || {}), ...{"middleware":["auth0","feature-flags-hooks"]} },
    component: () => import("/app/pages/auth/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: { ...(index06RuUPKkpIkYJ1u5ZQ6kHhkE76Z6rwcTsSwg0fLJR9IMeta || {}), ...{"middleware":["auth0","feature-flags-hooks"]} },
    component: () => import("/app/pages/login/index.vue")
  },
  {
    name: "reports",
    path: "/reports",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/reports/index.vue")
  },
  {
    name: "testbed",
    path: "/testbed",
    meta: { ...(indexo4LA2msHJdAhkTreUNmi16kssM8xQi3fuvGCmtIyx_458Meta || {}), ...{"middleware":["auth0","feature-flags-hooks"]} },
    component: () => import("/app/pages/testbed/index.vue")
  },
  {
    name: "accounts",
    path: "/accounts",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/accounts/index.vue")
  },
  {
    name: "rentroll",
    path: "/rentroll",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/rentroll/index.vue")
  },
  {
    name: "settings",
    path: "/settings",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/settings/index.vue")
  },
  {
    name: "analytics",
    path: "/analytics",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/analytics/index.vue")
  },
  {
    name: "opextracker",
    path: "/opextracker",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/opextracker/index.vue")
  },
  {
    name: "canvas-reports",
    path: "/canvas-reports",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/canvas-reports/index.vue")
  },
  {
    name: "portfolio-portfolioId",
    path: "/portfolio/:portfolioId()",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/[portfolioId].vue"),
    children: [
  {
    name: "portfolio-portfolioId-opex",
    path: "opex",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/[portfolioId]/opex/index.vue")
  },
  {
    name: "portfolio-portfolioId-balance",
    path: "balance",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/[portfolioId]/balance/index.vue")
  },
  {
    name: "portfolio-portfolioId-overview",
    path: "overview",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/[portfolioId]/overview/index.vue")
  },
  {
    name: "portfolio-portfolioId-companies",
    path: "companies",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/[portfolioId]/companies/index.vue")
  },
  {
    name: "portfolio-portfolioId-tenancies",
    path: "tenancies",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/[portfolioId]/tenancies/index.vue")
  },
  {
    name: "portfolio-portfolioId-properties",
    path: "properties",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/[portfolioId]/properties/index.vue")
  }
]
  },
  {
    name: "reports-layoutId",
    path: "/reports/:layoutId()",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/reports/[layoutId]/index.vue")
  },
  {
    name: "reports-layoutId-print",
    path: "/reports/:layoutId()/print",
    meta: { ...(print6uUuyU8UjrqAorMcD7dnN0BUCO2UB6mr1SJ9sUTGeIQMeta || {}), ...{"middleware":["auth0","feature-flags-hooks"]} },
    component: () => import("/app/pages/reports/[layoutId]/print.vue")
  },
  {
    name: datamappingZJmlTkd0VHccM0wtstRIg_455r9dwXJNDF7OS70DsYFL8Meta?.name,
    path: "/datamanagement/datamapping",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/datamanagement/datamapping.vue"),
    children: [
  {
    name: "datamanagement-datamapping",
    path: "",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/datamanagement/datamapping/index.vue")
  },
  {
    name: "datamanagement-datamapping-account-mapping",
    path: "account-mapping",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/datamanagement/datamapping/account-mapping/index.vue")
  },
  {
    name: "datamanagement-datamapping-tenancy-mapping",
    path: "tenancy-mapping",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/datamanagement/datamapping/tenancy-mapping/index.vue")
  },
  {
    name: "datamanagement-datamapping-category-mapping",
    path: "category-mapping",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/datamanagement/datamapping/category-mapping/index.vue")
  },
  {
    name: "datamanagement-datamapping-property-mapping",
    path: "property-mapping",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/datamanagement/datamapping/property-mapping/index.vue")
  },
  {
    name: "datamanagement-datamapping-portfolio-mapping",
    path: "portfolio-mapping",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/datamanagement/datamapping/portfolio-mapping/index.vue")
  },
  {
    name: "datamanagement-datamapping-custom-fields-mapping",
    path: "custom-fields-mapping",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/datamanagement/datamapping/custom-fields-mapping/index.vue")
  }
]
  },
  {
    name: "portfolio-tenancy-tenancyId",
    path: "/portfolio/tenancy/:tenancyId()",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/tenancy/[tenancyId].vue"),
    children: [
  {
    name: "portfolio-tenancy-tenancyId-sales",
    path: "sales",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/tenancy/[tenancyId]/sales/index.vue")
  },
  {
    name: "portfolio-tenancy-tenancyId-tenant",
    path: "tenant",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/tenancy/[tenancyId]/tenant/index.vue")
  },
  {
    name: "portfolio-tenancy-tenancyId-arrears",
    path: "arrears",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/tenancy/[tenancyId]/arrears/index.vue")
  },
  {
    name: "portfolio-tenancy-tenancyId-capexes",
    path: "capexes",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/tenancy/[tenancyId]/capexes/index.vue")
  },
  {
    name: "portfolio-tenancy-tenancyId-overview",
    path: "overview",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/tenancy/[tenancyId]/overview/index.vue")
  },
  {
    name: "portfolio-tenancy-tenancyId-valuations",
    path: "valuations",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/tenancy/[tenancyId]/valuations/index.vue")
  },
  {
    name: "portfolio-tenancy-tenancyId-account-statement",
    path: "account-statement",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/tenancy/[tenancyId]/account-statement/index.vue")
  }
]
  },
  {
    name: "datamanagement-pipelines",
    path: "/datamanagement/pipelines",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/datamanagement/pipelines/index.vue")
  },
  {
    name: "portfolio-property-propertyId",
    path: "/portfolio/property/:propertyId()",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/property/[propertyId].vue"),
    children: [
  {
    name: "portfolio-property-propertyId-opex",
    path: "opex",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/property/[propertyId]/opex/index.vue")
  },
  {
    name: "portfolio-property-propertyId-sales",
    path: "sales",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/property/[propertyId]/sales/index.vue")
  },
  {
    name: "portfolio-property-propertyId-units",
    path: "units",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/property/[propertyId]/units/index.vue")
  },
  {
    name: "portfolio-property-propertyId-balance",
    path: "balance",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/property/[propertyId]/balance/index.vue")
  },
  {
    name: "portfolio-property-propertyId-capexes",
    path: "capexes",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/property/[propertyId]/capexes/index.vue")
  },
  {
    name: "portfolio-property-propertyId-overview",
    path: "overview",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/property/[propertyId]/overview/index.vue")
  },
  {
    name: "portfolio-property-propertyId-valuations",
    path: "valuations",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/property/[propertyId]/valuations/index.vue")
  },
  {
    name: "portfolio-property-propertyId-actionplans",
    path: "actionplans",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/property/[propertyId]/actionplans/index.vue")
  },
  {
    name: "portfolio-property-propertyId-overview-old",
    path: "overview-old",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/property/[propertyId]/overview-old/index.vue")
  }
]
  },
  {
    name: "datamanagement-pipelines-index-old",
    path: "/datamanagement/pipelines/index-old",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/datamanagement/pipelines/index-old.vue")
  },
  {
    name: "datamanagement-integrationhub",
    path: "/datamanagement/integrationhub",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/datamanagement/integrationhub/index.vue")
  },
  {
    name: "datamanagement-pipelines-pipelineId",
    path: "/datamanagement/pipelines/:pipelineId()",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/datamanagement/pipelines/[pipelineId].vue")
  },
  {
    name: "datamanagement-integrationhub-integrationName",
    path: "/datamanagement/integrationhub/:integrationName()",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/datamanagement/integrationhub/[integrationName].vue")
  }
]